import { render, staticRenderFns } from "./houseChange.vue?vue&type=template&id=cc2d92ba&scoped=true&"
import script from "./houseChange.vue?vue&type=script&lang=js&"
export * from "./houseChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2d92ba",
  null
  
)

export default component.exports